import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import styles from './styles';

export default withStyles(styles)(Tabs);
